import type { VisitorCustomFieldConfig } from 'graphql-query-contracts';
import type { CustomFieldDetailModel } from './types';

export function mapQueryConfigsToDetailRows(
  configs: readonly VisitorCustomFieldConfig[]
): CustomFieldDetailModel[] {
  return configs.map(config => ({
    id: config.id,
    organizationId: config.organizationId,
    fieldKey: config.fieldKey,
    fieldName: config.fieldName,
    fieldType: config.fieldType,
    isEnabled: config.isEnabled,
    placeholder: config.placeholder ?? null,
    validationRegex: config.validationRegex ?? null,
    options: config.options
      ? config.options.map(({ displayText, value }) => ({ displayText, value }))
      : null,
    createdAtDatetime: config.createdAtDatetime ?? null,
    updatedAtDatetime: config.updatedAtDatetime ?? null,
  }));
}
